export default __webpack_public_path__ + "static/media/signup_banner_02.9262b67b.jpg";